export default function TeamCard({ team, onClick }) {
  const bildUrl = team.bild || null;
  const akzent  = team.akzentfarbe || "#003568";
  // trainer kann historisch (Sanity) ein Array von {name, rolle} sein,
  // oder aus dem neuen CMS-Formular ein einfacher String.
  const trainerListe = Array.isArray(team.trainer)
    ? team.trainer
    : team.trainer
    ? [{ name: team.trainer }]
    : [];

  return (
    <div
      className="bg-white border border-black/5 shadow-sm overflow-hidden group cursor-pointer hover:shadow-md transition-shadow"
      onClick={onClick}
    >
      {/* Headerbild */}
      {bildUrl && (
        <div className="h-56 overflow-hidden">
          <img
            src={bildUrl}
            alt={team.name}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      )}

      {/* Farbiger Akzent-Streifen */}
      <div className="h-1.5" style={{ backgroundColor: akzent }} />

      <div className="p-6">
        <h3 className="text-2xl font-extrabold uppercase">{team.name}</h3>
        <p className="text-sm text-dark/60 mt-1">
          {team.jahrgang}{team.jahrgang && team.liga ? " — " : ""}{team.liga}
        </p>

        {team.beschreibung && (
          <p className="mt-4 text-sm text-dark/70 leading-relaxed">{team.beschreibung}</p>
        )}

        {/* Trainer-Liste */}
        {trainerListe.length > 0 && (
          <div className="mt-5">
            <p className="text-xs font-bold uppercase tracking-wide text-dark/40 mb-2">Staff</p>
            <ul className="space-y-1">
              {trainerListe.map((t) => (
                <li key={t.name} className="flex items-center gap-2 text-sm">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent flex-shrink-0" />
                  <span className="font-medium">{t.name}</span>
                  {t.rolle && <span className="text-dark/50">— {t.rolle}</span>}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Spielplan-Button */}
        {team.spielplanUrl && (
          <a
            href={team.spielplanUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="mt-6 inline-flex items-center gap-2 bg-primary text-white text-xs font-bold uppercase tracking-wide px-4 py-2 hover:bg-accent transition-colors"
          >
            <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            Spielplan
          </a>
        )}
      </div>
    </div>
  );
}
